<template>
  <div class="bg-surface-100 min-h-screen font-inter">
    <slot />
  </div>
</template>
